<a routerLink="/">
  <img src="../../assets/logowhite.svg" alt="dots n pix logo" id="logoSmall">
</a>
<h1>Schedule</h1>
<ul>
    <li><a routerLink="/practical">9:30 Koffie</a></li>
    <li><a routerLink="/speaker/Dries Depoorter">10:00 Dries Depoorter</a></li>
    <li><a routerLink="/speaker/Es Devlin - POEM Paviljoen Dubai ">11:00 Es Devlin - POEM Paviljoen Dubai</a></li>
    <li><a routerLink="/practical">LUNCH</a></li>
    <li><a routerLink="/speaker/Neil Harbisson">13:00 Neil Harbisson</a></li>
    <li><a routerLink="/speaker/Stefan Sagmeister">14:00 Stefan Sagmeister</a></li>
    <li><a routerLink="/practical">BREAK</a></li>
    <li><a routerLink="/speaker/Neil Mendoza">15:30 Neil Mendoza</a></li>
    <li><a routerLink="/speaker/Daan Roosegaarde">16:30 Daan Roosegaarde</a></li>
    <li><a routerLink="/practical">BREAK</a></li>
    <li><a routerLink="/speaker/Seth Godin">17:00 Seth Godin</a></li>
</ul>